export enum ComparisonStatus {
    READY = 'ready',
    PROCESSING = 'processing',
    ERROR = 'error',
}
